<template>
  <div class="DetailsPage_box" v-wechat-title="this.title">
    <input type="hidden" id="shopId" v-model="shopId" />

    <!-- 二维码扫码预览 -->
    <template v-if="typeApp === 'preview'">
      <van-swipe class="component-box">
        <van-swipe-item v-for="(page, index) in multiplePageData" :key="index">
          <cusWidge
            :pageData="page.pageViewModular"
            :list="listPageComponents"
            :formConfig="formConfig"
            :key="index"
          ></cusWidge>
        </van-swipe-item>
      </van-swipe>
    </template>
    <!-- 终端使用 -->
    <template v-else>
      <template v-if="loding_show">
        <skeleton
          :class="typeTemplate === 'h5' ? 'component-box' : ''"
        ></skeleton>
      </template>
      <template>
        <template v-if="typeTemplate === 'h5'">          
          <!-- 下拉刷新 -->
          <template v-if="pull === 'Y'">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <mobile-view
                :pageData="pageData"
                :list="listPageComponents"
                :version="version"
                :firstId="firstId"
                :formConfig="formConfig"
              ></mobile-view>
              <!-- 底部提示 -->
              <div class="DetailsPage_footer" v-show="footShow">
                <div class="footer_left">
                  <span class="hengxian"></span>
                </div>
                <div class="text">已经到底了</div>
                <div class="footer_left">
                  <span class="hengxian"></span>
                </div>
              </div>
              <!-- 站位 -->
              <div style="height: 51px"></div>
            </van-pull-refresh>
          </template>
          <template v-else>
            <mobile-view
              :key="obj"
              v-if="strNew"
              :pageData="pageData"
              :version="version"
              :list="listPageComponents"
              :firstId="firstId"
              :formConfig="formConfig"
            ></mobile-view>
          </template>
        </template>
        <template v-else-if="typeTemplate === 'pc'">
          <pc-view
            :pageData="pageData"
            :list="listPageComponents"
            :version="version"
            :firstId="firstId"
            :formConfig="formConfig"
          ></pc-view>
        </template>

        <!-- 加载提示 -->
        <div class="loding_icon" v-show="loding_show">
          <van-loading type="spinner" color="#ccc">加载中...</van-loading>
        </div>
      </template>
    </template>
  </div>
</template>
 

<script>
// import timeComp from '../js/tooljs/timeComp'
// 接口
import { loadTemplate, loadPage } from "../api/index";
import CusWidge from "./cusWidge.vue";
import '../js/wx'
import '../js/rem'
import weixin from "../js/weixin.js"; // 微信分享js
import Vue from 'vue'
import wx from 'weixin-js-sdk'
import { whatUA,getUrlKey, publicNew} from '@/utils/index';
import { _check, encrypt, decrypt, getWebRoot } from "@/js/tooljs/utils.js";
import formConfig from "@/js/tooljs/sjPageConfig.js";
import Skeleton from "./components/skeleton.vue";
import MixinConfig from "@/mixin/index.js";
import MobileView from "./mobileView.vue";
import PcView from "./pcView.vue";
export default {
  name: "DetailsPage",
  components: { Skeleton, MobileView, PcView, CusWidge},
  mixins: [MixinConfig],
  computed: {
    typeTemplate() {
      return this.urlConfig && this.urlConfig.typeTemplate
        ? this.urlConfig.typeTemplate
        : "h5";
    },
    typeApp() {
      return this.urlConfig && this.urlConfig.application === "0"
        ? "preview"
        : "application";
    },
    pull() {
      return process.env.VUE_APP_PULL;
    },
  },
  data() {
    return {
      strNew: false,
      obj: '',
      shareId : '',
      shareChannel : '',
      shareOpenid : '',
      clueUniqueId : '',
      clueAcId : '',
      dataNew: {},
      // 当前页面的标题
      title: "",
      //模板数据
      tempalteData: null,
      //判断loding效果是否进行显示
      loding_show: true,
      // 判断下拉刷新效果是否显示
      isLoading: false,
      // 页面中的数据
      // pageData: null,
      pageData: {},
      // 页面中的组件数据
      listPageComponents:[],

      //控制自定义下拉刷新样式的显示隐藏
      topStatus: "",
      //判断是不是刷新
      RefreshFlag: false,
      //用户标识
      userSignStr: "",
      //iop组件的数据
      iopComponentsData: null,
      // 当前页面的url
      url: "",
      // 当前页面url中的所有参数
      urlData: null,
      // 当前用户的信息
      userVo: null,
      urlConfig: {}, //url携带参数
      footShow: false,
      multiplePageData: null, //多页面总数据
      version: "1", //多页面总数据
      shareAdvo: null,
      firstId: "", //默认获取第一个pageId
      shopId: this.$route.query.SHOP_ID,
      formConfig: formConfig, //页面属性
      pageTypeCode: "", //山西移动saas所属页面
    };
  },
  created() {
    let type = whatUA();
    if (type == "WECHAT") {
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          // 小程序环境
          if (getUrlKey('wechatParams')) {
          } else {
            var backUrl = '/pages/login/login?backurl=' + encodeURIComponent(window.location.href)
            wx.miniProgram.redirectTo({
              url: backUrl,
              fail(res) {
                  console.log("信息",res)
              }
            });
            return
          }
        }
      });
    }
    this.obj = publicNew(location.href).id
    // console.log(this.obj ,'监听id');
    // 获取当前页码的url中的参数
    this.urlConfig = this.getUrl(location.href)

    //测试 h5
    // this.urlConfig = this.getUrl(
    //   'https://sxwd.sinovatech.com/kshwap/#/DetailsPage?type=1&_su_pass=_sunc_vl&typeTemplate=h5&id=88285d61b6c044d3a78fc61fef8df19a&goodsId=deac84b9a26142b5b6d90a686f092f9c'
    // )
    //测试 pc

    // this.urlConfig = this.getUrl(
    //   'http://127.0.0.1/#/DetailsPage?type=1&_su_pass=_sunc_vl&typeTemplate=pc&id=328a5ef60aac4876bbef3874dcfca768&tplId=44fa73812ffe4cfa965e2a437b09eb7b&productId=5b0f8eef4f6c45da9ae7e1f90b3ca3a4&protypeId=cv27f8f19'
    // )
    // 2.2.7
    // this.urlConfig = this.getUrl(
    //   'http://172.16.39.11:19090/kshwap/#/DetailsPage?id=db2476e3e2d44644bcfa953250c60ae6&type=1&applicatioin=0&_su_pass=_sunc_vl&typeTemplate=h5'
    // )
    // http://172.16.39.11:19090/kshwap/#/DetailsPage?id=6ab832e54c8e45b8bb974c446197a825&type=0&_su_pass=_sunc_vl
    try {
      if (!!this.urlConfig.id) {
        this.getUserSignStr();
      }
    } catch (err) {
      console.log(err);
    }

    //页面title获取：
    if (this.$route.query.title) {
      // console.log('this.$route',this.$route)
      // console.log('this.$route',this.$route.query)
      this.title = this.$route.query.title
    }
  },
  mounted() {
    // // 回到顶部
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    // // 兼容IE
    // window.scrollTo(0, 0);

  },

  watch: {
    $route(to, from) {
      // console.log(this.$route.query,"================");
      console.info( "加载页面数据" );
      this.obj = publicNew(location.href).id
      console.log(this.obj ,'请求接口');
      this.strNew = false
      this.loding_show = true
      // created()
      // 获取当前页码的url中的参数
      this.urlConfig = this.getUrl(location.href)
      try {
        if (!!this.urlConfig.id) {
          this.getUserSignStr();
          this.loding_show = false
        }
      } catch (err) {
        console.log(err);
        this.loding_show = false
      }

      //页面title获取：
      if (this.$route.query.title) {
        // console.log('this.$route',this.$route)
        // console.log('this.$route',this.$route.query)
        this.title = this.$route.query.title
      }
    }
  },
  updated() {},
  methods: {
    // 监控页面滚动
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let bodyHeight = document.documentElement.offsetHeight;
      let pageHeight = document.querySelector(".component_box").offsetHeight;
      if (this.footShow) {
        let footHeight = document.querySelector(
          ".DetailsPage_footer"
        ).offsetHeight;
        if (scrollTop + bodyHeight < pageHeight - footHeight) {
          this.footShow = false;
        }
      } else {
        if (scrollTop + bodyHeight >= pageHeight) {
          this.footShow = true;
        }
      }
    },
    // 获取userSignStr
    async getUserSignStr() {
      // console.log(this.urlConfig,'入参')
      let channel = location.href
        .substring(location.href.indexOf("://") + 3)
        .split("/");
      let data = {
        id: this.urlConfig.id,
        channel: !!channel[4] ? channel[4] : "",
        _su_pass: !!this.urlConfig._su_pass ? this.urlConfig._su_pass : "",
        application: this.urlConfig.application || "1",
      };


      var url = window.location.href
      var obj = {}
      var arr1 = url.split('?')[1]
      if (!arr1) {
      } else {
        var arr2 = arr1.split('&')
        arr2.map(item=>{
        var arr3=item.split('=')
        obj[arr3[0]] = arr3[1]
      })
      obj = JSON.parse(JSON.stringify(obj))
      }
      this.shareId = obj.shareId ? obj.shareId : (sessionStorage.getItem("shareId")?sessionStorage.getItem("shareId"):'')
      this.shareChannel = obj.shareChannel ? obj.shareChannel : (sessionStorage.getItem("shareChannel")?sessionStorage.getItem("shareChannel"):'')
      this.shareOpenid = obj.shareOpenid ? obj.shareOpenid : (sessionStorage.getItem("shareOpenid")?sessionStorage.getItem("shareOpenid"):'')
      this.clueUniqueId = obj.clueUniqueId ? obj.clueUniqueId : (sessionStorage.getItem("clueUniqueId")?sessionStorage.getItem("clueUniqueId"):'')
      this.clueAcId = obj.clueAcId ? obj.clueAcId : (sessionStorage.getItem("clueAcId")?sessionStorage.getItem("clueAcId"):'')
      if (this.shareId) {
        sessionStorage.setItem('shareId',this.shareId);
      }
      if (this.shareChannel) {
        sessionStorage.setItem('shareChannel',this.shareChannel);
      }
      if (this.shareOpenid) {
        sessionStorage.setItem('shareOpenid',this.shareOpenid);
      }
      var dataOne = {
        dataType: 'share',
        shareId: this.shareId,
        shareChannel: this.shareChannel,
        shareOpenid: this.shareOpenid,
        title: '',
        // imageUrl: '$分享的图片url',
        shareUrl: url
      }
      if (this.clueUniqueId) {
        dataOne.clueUniqueId = this.clueUniqueId
      }
      if (this.clueAcId) {
        dataOne.clueAcId = this.clueAcId
      }
      // console.log(dataOne,'分享信息刚刚生成');
      if (this.urlConfig.type == 0) {
        //等于0是模板，否则是页面
        loadTemplate(data).then(({ data }) => {
          if (data.head.resultCode == "0000") {

            this.$store.commit("changeACT_ID", data.body.id);
            this.$store.commit("getpagesName", data.body.pageId);


            this.pageTypeCode = data.body.pageTypeCode;
            // console.log(
            //   this.pageTypeCode,
            //   "this.pageTypeCode  detailepage==>>"
            // );
            this.pageData = this.parseFun(
              JSON.parse(data.body.htmlCode),
              this.urlConfig.type,
              this.urlConfig.pageId
            )

            let objs = JSON.parse(data.body.htmlCode);
            let paramsObj = {};
            let ppkShareComponentObj = {};
            for (let itemIndex = 0; itemIndex < objs[0].pageViewModular.column.length; itemIndex++) {
              let item = objs[0].pageViewModular.column[itemIndex];
              if (item.bannerType == "ppkMusicBgc") {
                paramsObj = item;
              }
              if (item.bannerType == "ppkShareComponent") {
                ppkShareComponentObj = item;
              }
            }
            // console.log(paramsObj,"paramsObj");
            if (Object.values(paramsObj).length>0) {
              this.$store.commit(
                "changemusicParams",
                paramsObj.busiCode[1].isShow
              );
              this.$store.commit(
                "changemusicParamsURl",
                paramsObj.busiCode[1].musicUrl
              );
              if(paramsObj.busiCode[1].acid){
                this.$store.commit("getpagesName",paramsObj.busiCode[1].acid);
              }
              // console.log(paramsObj,'paramsObj');
              this.$store.commit("changemygiftbagImgUrl", {
                mygiftImg: paramsObj.busiCode[1].mygiftImg,
                mygift: paramsObj.busiCode[1].mygift,
              });
              // alert(this.$store.state.mygiftbagImgUrl.mygiftImg)
            }

            // console.log(ppkShareComponentObj,"ppkShareComponentObj");
            if ( Object.values(ppkShareComponentObj).length>0 ) {
              if (ppkShareComponentObj.busiCode[0].componentType == 'share') {
                // console.log(objs[0].name,"title",window.location.href,"href");
                // window.addEventListener('scroll', this.handleScroll)
                let type = whatUA();
                // console.log(wx.miniProgram.getEnv);
                if (type == "WECHAT") {
                  wx.miniProgram.getEnv(function (res) {
                    // console.log(res, "小程序res", !goods.detailsLink);
                    // console.log(res, "小程序小程序小程序小程序小程序");
                    if (res.miniprogram) {
                      // 小程序环境
                      var urlType = window.location.href
                      let urlTypeA = location.href.indexOf('wechatParams')
                      if(urlTypeA != "-1"){
                        if (window.location.href.split('?')[1].substr(0, 12) == 'wechatParams') {      
                        } else {
                          urlType = urlType.replace(/[\?&]wechatParams=[^&]*&?/g, '&')
                        }
                      }
                      dataOne.shareUrl = urlType
                      console.log(dataOne,'type为0嗷',urlType);
                      wx.miniProgram.postMessage({
                        data: dataOne
                      })
                    } else {
                      // console.log("不在小程序中");
                    }
                  });
                }
              }
            }




            // // ppkMusicBgc  活动页面设置组件
            // let paramsObj = objs[0].pageViewModular.column.find((item) => {
            //   return item.bannerType == "ppkMusicBgc";
            // });
            // if (paramsObj) {
            //   this.$store.commit(
            //     "changemusicParams",
            //     paramsObj.busiCode[1].isShow
            //   );
            //   this.$store.commit(
            //     "changemusicParamsURl",
            //     paramsObj.busiCode[1].musicUrl
            //   );
            //   if(paramsObj.busiCode[1].acid){
            //     this.$store.commit("getpagesName",paramsObj.busiCode[1].acid);
            //   }
            //   console.log(paramsObj,'paramsObj');
            //   this.$store.commit("changemygiftbagImgUrl", {
            //     mygiftImg: paramsObj.busiCode[1].mygiftImg,
            //     mygift: paramsObj.busiCode[1].mygift,
            //   });
            //   // alert(this.$store.state.mygiftbagImgUrl.mygiftImg)
            // }

            // // ppkShareComponent  品牌库分享组件
            // let ppkShareComponentObj = objs[0].pageViewModular.column.find((item) => {
            //   return item.bannerType == "ppkShareComponent";
            // });
            // console.log(ppkShareComponentObj,"ppkShareComponentObj");
            // if (ppkShareComponentObj) {
            //   console.log(objs[0].name,"title",window.location.href,"href");
            //   // window.addEventListener('scroll', this.handleScroll)
            //   let type = whatUA();
            //   // console.log(wx.miniProgram.getEnv);
            //   if (type == "WECHAT") {
            //     wx.miniProgram.getEnv(function (res) {
            //       console.log(res, "小程序res", !goods.detailsLink);
            //       if (res.miniprogram) {
            //         // 小程序环境
            //         wx.miniProgram.postMessage({
            //           data: {
            //             title: objs[0].name,
            //             // imageUrl: '$分享的图片url',
            //             shareUrl: window.location.href
            //           }
            //         })
            //       } else {
            //         console.log("不在小程序中");
            //       }
            //     });
            //   }
            // }



            // console.log(this.pageData);
            let newArr = this.pageData.column;
            // console.log(newArr,"--->");
            for (let index = 0; index < newArr.length; index++) {
              let el = newArr[index];
              if (el.bannerType == "ppkCountDown") {
                let obj = {...el};
                obj.isCompound = "3";
                el.column.unshift(obj)
                // console.log(el,"--->")
              }
            }
            this.pageData.column = newArr;


            this.listPageComponents = this.pageData.column
            // console.log(JSON.parse(data.body.htmlCode),'ccccc====>>')
            this.loding_show = false
            this.content_show = true
            // console.log(this.pageData, '组件内数据===================')
            // this.main(this.pageData)
            
            //页面title获取：
            // console.log(this.pageData.pageConfig);
            if (this.pageData.pageConfig) {
              // console.log(this.pageData.pageConfig)
              this.title = this.pageData.pageConfig.name
            }
          } else {
            this.loding_show = false;
            // this.$toast.fail(data.head.resultMsg)
            // 去一个缺省页
            this.$empty.show(data.head.resultMsg);
          }
        });
      } else {
        loadPage(data).then(({ data }) => {
          if (data.head.resultCode == "0000") {
            this.strNew = true
            this.loding_show = false
            this.$store.commit("changeACT_ID", data.body.id);
            this.$store.commit("getpagesName", data.body.pageId);
            Vue.prototype.$pageId = data.body.pageId


            this.pageTypeCode = data.body.pageTypeCode;
            // console.log(
            //   this.pageTypeCode,
            //   "this.pageTypeCode  detailepage==>>2"
            // );
            this.pageData = this.parseFun(
              JSON.parse(data.body.htmlCode),
              this.urlConfig.type,
              this.urlConfig.pageId

            );


            let objs = JSON.parse(data.body.htmlCode);
            let paramsObj = {};
            let ppkShareComponentObj = {};
            for (let itemIndex = 0; itemIndex < objs[0].pageViewModular.column.length; itemIndex++) {
              let item = objs[0].pageViewModular.column[itemIndex];
              if (item.bannerType == "ppkMusicBgc") {
                paramsObj = item;
              }
              if (item.bannerType == "ppkShareComponent") {
                ppkShareComponentObj = item;
              }
            }
            // console.log(paramsObj,"paramsObj");
            if ( Object.values(paramsObj).length>0 ) {
              this.$store.commit(
                "changemusicParams",
                paramsObj.busiCode[1].isShow
              );
              this.$store.commit(
                "changemusicParamsURl",
                paramsObj.busiCode[1].musicUrl
              );
              if(paramsObj.busiCode[1].acid){
                this.$store.commit("getpagesName",paramsObj.busiCode[1].acid);
              }
              // console.log(paramsObj,'paramsObj');
              this.$store.commit("changemygiftbagImgUrl", {
                mygiftImg: paramsObj.busiCode[1].mygiftImg,
                mygift: paramsObj.busiCode[1].mygift,
              });
              // alert(this.$store.state.mygiftbagImgUrl.mygiftImg)
            }

            // console.log(ppkShareComponentObj,"ppkShareComponentObj");
            if ( Object.values(ppkShareComponentObj).length>0 ) {
              // console.log(objs[0].name,"title",window.location.href,"href");
              if (ppkShareComponentObj.busiCode[0].componentType == 'share') {
                // window.addEventListener('scroll', this.handleScroll)
                let type = whatUA();
                // console.log(wx.miniProgram.getEnv);
                if (type == "WECHAT") {
                  wx.miniProgram.getEnv(function (res) {
                    // console.log(res, "小程序res", !goods.detailsLink);
                    // console.log(res, "小程序小程序小程序小程序",);
                    if (res.miniprogram) {
                      // 小程序环境
                      var urlTypeOne = window.location.href
                      let urlTypeB = location.href.indexOf('wechatParams')
                      if(urlTypeB != "-1"){
                        if (window.location.href.split('?')[1].substr(0, 12) == 'wechatParams') {      
                        } else {
                          urlTypeOne = urlTypeOne.replace(/[\?&]wechatParams=[^&]*&?/g, '&')
                        }
                      }
                      dataOne.shareUrl = urlTypeOne
                      console.log(dataOne,'分享信息小程序',urlTypeOne);
                      wx.miniProgram.postMessage({
                        data: dataOne
                      })
                    } else {
                      // console.log("不在小程序中");
                    }
                  });
                }
              }
            }


            // // ppkMusicBgc  活动页面设置组件
            // let paramsObj = objs[0].pageViewModular.column.find((item) => {
            //   return item.bannerType == "ppkMusicBgc";
            // });
            // console.log(paramsObj,"=======>");
            // if (paramsObj) {
            //   this.$store.commit(
            //     "changemusicParams",
            //     paramsObj.busiCode[1].isShow
            //   );
            //   this.$store.commit(
            //     "changemusicParamsURl",
            //     paramsObj.busiCode[1].musicUrl
            //   );
            //   if(paramsObj.busiCode[1].acid){
            //     this.$store.commit("getpagesName",paramsObj.busiCode[1].acid);
            //   }
            //   console.log(paramsObj,'paramsObj');
            //   this.$store.commit("changemygiftbagImgUrl", {
            //     mygiftImg: paramsObj.busiCode[1].mygiftImg,
            //     mygift: paramsObj.busiCode[1].mygift,
            //   });
            //   // alert(this.$store.state.mygiftbagImgUrl.mygiftImg)
            // }

            // // ppkShareComponent  品牌库分享组件
            // let ppkShareComponentObj = objs[0].pageViewModular.column.find((item) => {
            //   return item.bannerType == "ppkShareComponent";
            // });
            // console.log(ppkShareComponentObj,"ppkShareComponentObj");
            // if (ppkShareComponentObj) {
            //   console.log(objs[0].name,"title",window.location.href,"href");
            //   // window.addEventListener('scroll', this.handleScroll)
            //   let type = whatUA();
            //   // console.log(wx.miniProgram.getEnv);
            //   if (type == "WECHAT") {
            //     wx.miniProgram.getEnv(function (res) {
            //       console.log(res, "小程序res", !goods.detailsLink);
            //       if (res.miniprogram) {
            //         // 小程序环境
            //         wx.miniProgram.postMessage({
            //           data: {
            //             title: objs[0].name,
            //             // imageUrl: '$分享的图片url',
            //             shareUrl: window.location.href
            //           }
            //         })
            //       } else {
            //         console.log("不在小程序中");
            //       }
            //     });
            //   }
            // }


            // console.log(this.pageData);
            let newArr = this.pageData.column;
            // console.log(newArr,"--->");
            for (let index = 0; index < newArr.length; index++) {
              let el = newArr[index];
              if (el.bannerType == "ppkCountDown") {
                let obj = {...el};
                obj.isCompound = "3";
                el.column.unshift(obj)
                // console.log(el,"--->")
              }
            }
            this.pageData.column = newArr;

            this.listPageComponents = this.pageData.column
            // console.log(JSON.parse(data.body.htmlCode), "ccccc====>>");

            this.loding_show = false;
            this.content_show = true;
            // this.main(this.pageData);


                        
            //页面title获取：
            // console.log(this.pageData.pageConfig);
            if (this.pageData.pageConfig) {
              // console.log(this.pageData.pageConfig)
              this.title = this.pageData.pageConfig.name
            }
          } else {
            this.loding_show = false;
            // this.$toast.fail(data.head.resultMsg)
            this.$empty.show(data.head.resultMsg);
          }
        });
      }

      const that = this;
      // 刷新时才执行
      if (this.RefreshFlag) {
        setTimeout(() => {
          // 页面刷新完成
          that.isLoading = false;
          that.$toast.success("刷新成功!");
        }, 0);
      }
    },

    // 判断是单页面还是多页面  1 单页面  2 多页面
    isVersion(data) {
      if (
        Array.isArray(data) &&
        data.length > 0 &&
        data["0"].hasOwnProperty("pageViewModular")
      ) {
        return "2";
      }
      return "1";
    },
    // 解析数据
    // 数据，分类（模板，页面）
    parseFun(data, type, pageId) {
      // console.log('数据解析');
      let res;
      if (data && data.length > 1) {
        this.firstId = data[0].pageId; //判断是否可以展示goodsaction
      }
      if (type == 0) {
        if (this.isVersion(data) == "2") {
          // 多页面
          this.version = "2";
          if (pageId) {
            res = data.find((item) => item.pageId == pageId).pageViewModular;
          } else {
            //如果url没有pageId默认找回显一个页面
            res = data[0].pageViewModular;
            this.multiplePageData = data;
          }
        } else {
          //单页面
          res.list = data;
        }
      } else if (type == 1) {
        // console.log('类型');
        if (this.isVersion(data) == "2") {
          // 多页面
          this.version = "2";
          if (pageId) {
            res = data.find((item) => item.pageId == pageId).pageViewModular;
          } else {
            res = data[0].pageViewModular;
            this.multiplePageData = data;
          }
        } else {
          //单页面
          for (let i = 0; i < data.length; i++) {
            data[i].busiCode = eval(data[i].busiCode);
          }
          res.list = data;
        }
      }

      return res;
    },

    // 下拉刷新时触发的函数
    onRefresh() {
      this.RefreshFlag = true;
    },

    // 获取url上的参数
    getUrl(url) {
      if (url.indexOf("?") != -1) {
        let theRequest = new Object();
        let num = url.indexOf("?") + 1;
        let str = url.substr(num);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
        return theRequest;
      } else {
        return;
      }
    },
  },
}
</script>
<style lang="scss" scoped>
/* 兼容IOS */
body{
    /* 禁止用户自定义设置字体大小 */
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
    /* 禁止用户自定义设置字体大小 */
}
.DetailsPage_box {
  width: 100%;
  // min-width: 15rem;
  height: auto;
  font-size: 0.24rem;
  & .van-skeleton {
    flex-direction: row-reverse;
  }
}
.component-box {
  background: #f2f2f2;
  width: 100%;
  height: 100%;
  // padding-bottom: 1.2rem;
}
/* css注释：设置了浏览器宽度不小于1201px时 abc 显示1200px宽度 */
@media screen and (min-width: 750px) {
  .component-box {
    width: 750px;
    height: 100%;
    margin: 0 auto;
    // user-select: none;
  }
}
.title_fixed {
  height: 0.64rem;
  line-height: 0.64rem;
  text-align: center;
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}
.loding_icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  // background-color: rgba(000, 000, 000, 0.5);
  background: #fff;
  .van-loading {
    display: flex;
    justify-content: center;
    .van-loading__text {
      // color: #ffffff;
      line-height: 0.6rem;
    }
  }
}
.DetailsPage_footer {
  width: 100%;
  height: 0.5rem;
  background-color: #fff;
  display: flex;
  justify-content: center;
  font-size: 0.2rem;
  padding-bottom: 0.2rem;
  > .footer_left {
    display: flex;
    align-items: center;
    width: 1rem;
    height: 100%;
    .hengxian {
      display: block;
      width: 100%;
      height: 0.02rem;
      background-color: #bfbfc0;
    }
  }
  .text {
    padding: 0 0.2rem;
    color: #a2a2a2;
  }
}
// 对刷新组件的设置
.mt-loadmore {
  padding-bottom: 1.2rem;
}
/deep/ .is-dropped {
  position: relative;
  transition: all linear 0.3s;
}
// 下拉时显示的内容样式
.zidingyi {
  height: 50px;
  width: 100%;
  position: absolute;
  top: -50px;
  background-color: rgba(000, 000, 000, 0.05);
  .loding_top_box {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
  .loding_top_box2 {
    display: block;
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
  }
}
/deep/.mint-loadmore-bottom {
  display: none;
}
</style>
